import * as ticketsActions from '../actions/Tickets';

const initialState = {
  list: [],
  offset: 0,
  limit: 10,
  count: 7,
  error: false,
  status: 200,
  error_message: ''
};

const tickets = (state = initialState, action) => {
  switch (action.type) {
    case ticketsActions.GET_TICKETS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case ticketsActions.GET_TICKETS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default tickets;
